import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { v1Api } from '../../services/api';
import { SeasonOverviewData } from '../../types';
import Card from '../../components/common/Card';
import Skeleton from '../../components/common/Skeleton';
import SeasonOverview from '../../components/roster/SeasonOverview';

const RosterSeasonView: React.FC = () => {
  const { teamId, espnLeagueId } = useParams<{ teamId: string; espnLeagueId: string }>();
  const navigate = useNavigate();
  // const context = useContext(TeamContext) as TeamContextData;
  
  const [seasonOverview, setSeasonOverview] = useState<SeasonOverviewData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadSeasonOverview = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const data = await v1Api.teams.getSeasonOverview(parseInt(teamId!));
        setSeasonOverview(data);
      } catch (err) {
        console.error('Error loading season overview:', err);
        setError('Failed to load season overview data. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    if (teamId) {
      loadSeasonOverview();
    }
  }, [teamId]);

  if (loading) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-64 w-full" />
        <Skeleton className="h-48 w-full" />
      </div>
    );
  }

  if (error) {
    return (
      <Card className="p-6">
        <div className="text-center">
          <div className="text-accent-danger mb-4 flex items-center justify-center gap-2">
            <AlertTriangle className="w-5 h-5" />
            {error}
          </div>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-accent-primary text-background-primary rounded font-medium hover:brightness-110 transition-all active:translate-y-px"
          >
            Retry
          </button>
        </div>
      </Card>
    );
  }

  if (!seasonOverview) {
    return (
      <Card className="p-6">
        <div className="text-center text-text-secondary">
          No season overview data available for this team.
        </div>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <SeasonOverview
        data={seasonOverview}
        onDraftPlayerClick={(playerId) =>
          navigate(`/leagues/espn/${espnLeagueId}/players/${playerId}`)
        }
      />
    </div>
  );
};

export default RosterSeasonView;